import React, { useState } from 'react';
import MessageInputShell from '../FarChat/MessageInputShell';

/** In-session purchase follow-ups accept text only, including Enter to send. */
const PurchaseFollowupInput: React.FC<{
  onSend: (message: string) => void | Promise<void>;
  placeholder: string;
  disabled: boolean;
}> = ({ onSend, placeholder, disabled }) => {
  const [text, setText] = useState('');
  const send = () => {
    if (disabled || !text.trim()) return;
    const message = text.trim();
    setText('');
    void onSend(message);
  };

  return <MessageInputShell
    value={text}
    onChange={setText}
    onSend={send}
    onAttachClick={() => {}}
    showAttachments={false}
    onKeyDown={(event) => {
      if (event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault();
        send();
      }
    }}
    disabled={disabled}
    placeholder={placeholder}
  />;
};



export default PurchaseFollowupInput;
